import createSwipeGallery from '@PROJECT_ROOT/assets/mobile/js/swipeGallery';
import initBlogMenu from '@PROJECT_ROOT/assets/mobile/js/blog/menu';
import initFloatingBar from '@PROJECT_ROOT/assets/shared/js/library/floatingBar';

$(() => {
    setUpGalleries();
    initBlogMenu();
    initFloatingBar('.socialIcons', 'bottom');
});

function setUpGalleries() {
    const images = JSON.parse(document.getElementById('gallery').getAttribute('data-source'));
    const imagesCounter = images ? images.length : 0;

    if (imagesCounter > 0) {
        createSwipeGallery('#gallery', images);
    }
}
